import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { TaskListItem as TaskListItemType } from "@myapp/contract";
import Loader from "../../../../shared/ui/feedback/Loader/Loader";
import { AufgabenListItem } from "./AufgabenListItem";

interface AufgabenListViewProps {
  items: TaskListItemType[];
  isLoading: boolean;
  isFetchingNextPage: boolean;
  hasMore: boolean;
  onLoadMore: () => void;
}

export const AufgabenListView: React.FC<AufgabenListViewProps> = ({
  items,
  isLoading,
  isFetchingNextPage,
  hasMore,
  onLoadMore,
}) => {
  if (isLoading && !items.length) {
    return (
      <div className="my-10 flex w-full justify-center">
        <Loader />
      </div>
    );
  }

  if (!items.length) {
    return (
      <p className="my-10 w-full text-center font-['PT_Sans'] text-[20px] font-bold text-primary">
        Keine Aufgaben für die aktuellen Filter.
      </p>
    );
  }

  return (
    <InfiniteScroll
      dataLength={items.length}
      next={onLoadMore}
      hasMore={hasMore}
      loader={
        <div className="my-4 flex w-full justify-center">
          <Loader size="small" />
        </div>
      }
      scrollableTarget="scrollableDiv"
      style={{ overflow: "visible" }}
    >
      <div className="flex w-full flex-col gap-4">
        {items.map((item) => (
          <AufgabenListItem key={item.id} item={item} />
        ))}
      </div>

      {isFetchingNextPage && (
        <div className="my-4 flex w-full justify-center">
          <Loader size="small" />
        </div>
      )}
    </InfiniteScroll>
  );
};
